import { useState } from 'react';
import {
  Button,
  Cluster,
  Container,
  FoldPanel,
  Panel,
  Specimens,
  Stack,
  Switch,
  Typography,
  Well,
} from '@src/components';

export function PanelSection() {
  const [elevated, setElevated] = useState(false);

  return (
    <FoldPanel
      id="panels"
      title="Panels"
      hint="The surface a screen is built from. This page is made of them — every section below is a Panel."
      example={`<Panel padding="medium" elevated>
  A quiet box for a form, a setting, a block of copy.
</Panel>`}
    >
      <Specimens
        label="Default"
        note="Hairline, surface fill, 2xl radius. The same chrome as the section you are reading."
      >
        <Well>
          <Container width="narrow">
            <Panel padding="medium">
              <Stack gap={4}>
                <Typography as="p" role="body/sm">
                  A quiet box for a form, a setting, a block of copy.
                </Typography>
                <Cluster justify="end">
                  <Button size="small">Continue</Button>
                </Cluster>
              </Stack>
            </Panel>
          </Container>
        </Well>
      </Specimens>

      <Specimens
        label="Elevated"
        note="The same panel with a lift, for something that should sit above the page."
      >
        <Well>
          <Container width="narrow">
            <Panel padding="medium" elevated>
              <Stack gap={4}>
                <Typography as="p" role="body/sm">
                  A shadow, still blueberry-free — coral stays on actions.
                </Typography>
                <Cluster justify="end">
                  <Button size="small" variant="soft">
                    Soft action
                  </Button>
                </Cluster>
              </Stack>
            </Panel>
          </Container>
        </Well>
      </Specimens>

      <Specimens
        label="Padding"
        note="None, small, medium, large. Large is what the kit sections use."
      >
        <Well>
          <Cluster gap={4} align="start">
            <Panel padding="small">
              <Typography role="body/sm">small</Typography>
            </Panel>
            <Panel padding="medium">
              <Typography role="body/sm">medium</Typography>
            </Panel>
            <Panel padding="large">
              <Typography role="body/sm">large</Typography>
            </Panel>
          </Cluster>
        </Well>
      </Specimens>

      <Specimens label="Playground" note="Toggle the lift on a live panel.">
        <Stack gap={4}>
          <Switch label="Elevated" checked={elevated} onCheckedChange={setElevated} />
          <Well>
            <Container width="narrow">
              <Panel padding="medium" elevated={elevated}>
                <Typography as="p" role="body/sm">
                  {elevated ? 'Lifted off the page.' : 'Sitting in the page.'}
                </Typography>
              </Panel>
            </Container>
          </Well>
        </Stack>
      </Specimens>
    </FoldPanel>
  );
}
